import { Link } from 'react-router-dom';

function HomePage() {
  const s = {
    hero: {
      background: 'linear-gradient(135deg, #0D1B2A 0%, #1B3A5C 100%)',
      color: '#fff',
      padding: '140px 40px 100px',
      textAlign: 'center',
    },
    heroTitle: {
      fontFamily: 'Georgia, serif',
      fontSize: 48,
      fontWeight: 700,
      marginBottom: 20,
      maxWidth: 800,
      margin: '0 auto 20px',
      lineHeight: 1.2,
    },
    heroSubtitle: {
      fontSize: 18,
      color: 'rgba(255,255,255,0.8)',
      maxWidth: 640,
      margin: '0 auto 36px',
      lineHeight: 1.6,
    },
    heroBtn: {
      display: 'inline-block',
      background: '#C9A84C',
      color: '#0D1B2A',
      padding: '16px 40px',
      borderRadius: 8,
      fontWeight: 700,
      fontSize: 16,
      textDecoration: 'none',
    },
    section: { padding: '80px 40px', maxWidth: 1100, margin: '0 auto' },
    sectionTitle: {
      fontFamily: 'Georgia, serif',
      fontSize: 32,
      fontWeight: 700,
      color: '#0D1B2A',
      textAlign: 'center',
      marginBottom: 48,
    },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 32 },
    card: { textAlign: 'center', padding: 32 },
    icon: { fontSize: 40, marginBottom: 16 },
    cardTitle: { fontSize: 18, fontWeight: 700, color: '#0D1B2A', marginBottom: 10 },
    cardText: { fontSize: 14, color: '#6B7280', lineHeight: 1.6 },
    categoriesBox: { background: '#F8F6F0', padding: '80px 40px' },
    catGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 20, maxWidth: 1100, margin: '0 auto' },
    catCard: {
      background: '#fff', borderRadius: 12, border: '1px solid #E2DECE',
      padding: 32, textAlign: 'center', textDecoration: 'none', display: 'block',
    },
    catIcon: { fontSize: 36, marginBottom: 12 },
    catName: { fontSize: 16, fontWeight: 700, color: '#0D1B2A' },
    ctaBox: {
      background: '#0D1B2A', color: '#fff', padding: '80px 40px', textAlign: 'center',
    },
    ctaTitle: { fontFamily: 'Georgia, serif', fontSize: 30, fontWeight: 700, marginBottom: 16 },
    ctaText: { fontSize: 16, color: 'rgba(255,255,255,0.75)', marginBottom: 32, maxWidth: 560, margin: '0 auto 32px' },
    contactBox: { padding: '80px 40px', textAlign: 'center' },
    contactItem: { fontSize: 16, color: '#0D1B2A', marginBottom: 8 },
    contactLink: { color: '#1B3A5C', fontWeight: 600, textDecoration: 'none' },
  };

  return (
    <div>
      {/* HERO */}
      <div style={s.hero}>
        <h1 style={s.heroTitle}>
          Оптова торгівля європейськими брендами для вашого бізнесу
        </h1>
        <p style={s.heroSubtitle}>
          Rocca B2B — широкий вибір якісних товарів європейських брендів
          та найнижчі ціни на ринку. Побутова хімія, продукти харчування
          та товари для дому — все в одному місці для оптових клієнтів.
        </p>
        <Link to="/catalog" style={s.heroBtn}>Перейти до каталогу</Link>
      </div>

      {/* ПЕРЕВАГИ */}
      <div style={s.section}>
        <h2 style={s.sectionTitle}>Чому обирають Rocca B2B</h2>
        <div style={s.grid}>
          <div style={s.card}>
            <div style={s.icon}>🇪🇺</div>
            <div style={s.cardTitle}>Європейські бренди</div>
            <div style={s.cardText}>
              Працюємо напряму з перевіреними постачальниками з Європи —
              гарантія якості кожної партії товару.
            </div>
          </div>
          <div style={s.card}>
            <div style={s.icon}>💰</div>
            <div style={s.cardTitle}>Найнижчі ціни на ринку</div>
            <div style={s.cardText}>
              Оптові умови без посередників — вигідна ціна для вашого
              бізнесу на кожну позицію каталогу.
            </div>
          </div>
          <div style={s.card}>
            <div style={s.icon}>📦</div>
            <div style={s.cardTitle}>Широкий асортимент</div>
            <div style={s.cardText}>
              Побутова хімія, продукти харчування, товари для дітей та
              дому — тисячі позицій в одному каталозі.
            </div>
          </div>
        </div>
      </div>

      {/* КАТЕГОРІЇ */}
      <div style={s.categoriesBox}>
        <h2 style={s.sectionTitle}>Категорії товарів</h2>
        <div style={s.catGrid}>
          <Link to="/catalog?cat=chemistry" style={s.catCard}>
            <div style={s.catIcon}>🧴</div>
            <div style={s.catName}>Побутова хімія</div>
          </Link>
          <Link to="/catalog?cat=продукти" style={s.catCard}>
            <div style={s.catIcon}>🍽️</div>
            <div style={s.catName}>Продукти харчування</div>
          </Link>
          <Link to="/catalog?cat=підгузники" style={s.catCard}>
            <div style={s.catIcon}>🍼</div>
            <div style={s.catName}>Підгузники</div>
          </Link>
          <Link to="/catalog?cat=товари-для-дітей" style={s.catCard}>
            <div style={s.catIcon}>👶</div>
            <div style={s.catName}>Товари для дітей</div>
          </Link>
          <Link to="/catalog" style={s.catCard}>
            <div style={s.catIcon}>🏠</div>
            <div style={s.catName}>Товари для дому</div>
          </Link>
        </div>
      </div>

      {/* CTA */}
      <div style={s.ctaBox}>
        <h2 style={s.ctaTitle}>Готові почати співпрацю?</h2>
        <p style={s.ctaText}>
          Зареєструйтесь як оптовий клієнт і отримайте доступ до повного
          каталогу товарів за найкращими цінами.
        </p>
        <Link to="/login" style={s.heroBtn}>Зареєструватись</Link>
      </div>

      {/* КОНТАКТИ */}
      <div style={s.contactBox}>
        <h2 style={s.sectionTitle}>Контакти</h2>
        <div style={s.contactItem}>
          📞 <a href="tel:+380775528288" style={s.contactLink}>+380 77 552 82 88</a>
        </div>
        <div style={s.contactItem}>
          🌐 b2b.rocca.com.ua
        </div>
      </div>
    </div>
  );
}

export default HomePage;
